/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import { gql } from '@apollo/client';

export const CHECK_RESTRICTIONS = gql`
   mutation checkRestrictions($input: MobileRestrictionsInput) {
     checkRestrictions(input: $input) {
       success
       redirectUrl
     }
   }
 `;

export const GET_RESTRICTIONS = gql`
query restrictions {
  restrictions {
    deviceRestrictions {
      device
      os { name, minVersion, excludedVersions }
      browsers { name, minVersion, excludedVersions }
    }
    invitationLink
  }
}
`;
